import { BreadCrumbModel } from '@/modules/shared/models/breadcrumb';
import i18n from '@/plugins/i18n';
import { Route } from 'vue-router';

const Breadcrumbs = {
  requestList: [{
    external: true,
    text: i18n.t('shared.eServices') as string,
    href: '/dashboard/portal-services',
  },
  {
    text: i18n.t('shared.judicialTableegh'),
    href: '/requests',
  }] as BreadCrumbModel[],
  delegatorConfirm: [{
    external: true,
    text: i18n.t('shared.eServices') as string,
    href: '/dashboard/portal-services',
  },
  {
    text: i18n.t('shared.judicialTableegh'),
    href: '/requests',
  }] as BreadCrumbModel[],

  chooseRequest: [{
    external: true,
    text: i18n.t('shared.eServices') as string,
    href: '/dashboard/portal-services',
  },
  {
    text: i18n.t('shared.judicialTableegh'),
    href: '/requests',
  },
  {
    text: i18n.t('requests.newRequest'),
    href: '/choose-request',
  },
  ] as BreadCrumbModel[],

  financialClaimRequest: () => {
    const links = [{
      external: true,
      text: i18n.t('shared.eServices') as string,
      href: '/dashboard/portal-services',
    },
    {
      text: i18n.t('shared.judicialTableegh'),
      href: '/requests',
    }] as BreadCrumbModel[];
    const financialClaimServiceId = window.$config?.serviceIds?.financialClaim || '';

    if (financialClaimServiceId) {
      links.push({
        external: true,
        text: i18n.t('requests.financialClaim') as string,
        href: `/dashboard/service-detail/${financialClaimServiceId}`,
      });
    }

    links.push({
      text: i18n.t('requests.financialClaimRequest') as string,
      href: '/requests/financial-claim',
    });

    return links;
  },
  financialClaimRequestDetails: (route: Route) => ([{
    external: true,
    text: i18n.t('shared.eServices') as string,
    href: '/dashboard/portal-services',
  },
  {
    text: i18n.t('requests.financialClaimNo', { claimNumber: route.hash.split('#')[1] || route.params.id }) as string,
    href: `/requests/financial-claim/${route.params.id}`,
  },
  ] as BreadCrumbModel[]),

  addDelegatorDetails: () => ([
    {
      text: i18n.t('requests.addDelegatorDetails'),
      href: '/requests',
    },

  ] as BreadCrumbModel[]),

  verification: (route: Route, isLoggedIn = true) => {
    const requiredApp = isLoggedIn ? 'dashboard' : 'landing';
    const linkBase = `/applications/${requiredApp}`;

    return [{
      external: true,
      text: i18n.t('shared.verificationServices') as string,
      href: isLoggedIn ? `${linkBase}/portal-services?verificationServices=true` : `${linkBase}/e-services?verificationServices=true`,
    },
    {
      text: i18n.t('requests.jtpVerification'),
      href: '/requests/verification',
    },
    ] as BreadCrumbModel[];
  },
  verificationResult: (route: Route, isLoggedIn = true) => {
    const requiredApp = isLoggedIn ? 'dashboard' : 'landing';
    const linkBase = `/applications/${requiredApp}`;

    return [
      {
        external: true,
        text: i18n.t('shared.verificationServices') as string,
        href: isLoggedIn ? `${linkBase}/portal-services?verificationServices=true` : `${linkBase}/e-services?verificationServices=true`,
      },
      {
        text: i18n.t('requests.jtpVerification'),
        href: '/requests/verify',
      },
      {
        text: i18n.t('requests.financialClaimNo', { claimNumber: `${route.params.id}#` }),
        href: `/requests/verify/${route.params.id}`,
      },
    ] as BreadCrumbModel[];
  },
};
export default Breadcrumbs;
